import { createSlice } from "@reduxjs/toolkit";

const initialUserssState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  userForEdit: undefined,
  error: null,
  navigate: false,
  userAccess: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const usersSlice = createSlice({
  name: "users",
  initialState: initialUserssState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.navigate = false;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    userFetched: (state, action) => {
      state.actionsLoading = false;
      state.userForEdit = {
        ...action.payload.userForEdit,
      };
      state.error = null;
    },
    usersFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
    },
    userCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.navigate = true;
    },
    userUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.navigate = true;
    },
    userDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },

    userRoleAccess: (state, action) => {
      const { entities } = action.payload;
      state.userAccess = entities;
    },
  },
});
